import { useCoreEvents, eventNames } from '@carvana/core-events';
import { useEffectOnce } from '@carvana/merch-react-hooks';
import { useContext, useState } from 'react';
import useSavedSearchApplied from '~/components/MainLayout/SearchHeader/SaveSearch/useSavedSearchApplied';
import AppliedFiltersContext from '~/contexts/AppliedFiltersContext';
import { useSavedSearchesIsLoaded } from '~/contexts/SavedSearchesContext';
import StaticContext from '~/contexts/StaticContext';
import UserContext from '~/contexts/UserContext';
import useLoginAndSaveSearch from '~/hooks/useLoginAndSaveSearch';

export default function useSaveSearchOnLoad() {
  const { appliedFilters } = useContext(AppliedFiltersContext);
  const { utmCampaign } = useContext(StaticContext);
  const loginAndSaveSearch = useLoginAndSaveSearch();
  const isSavedSearchesLoaded = useSavedSearchesIsLoaded();
  const savedSearchIsApplied = useSavedSearchApplied();
  const { user } = useContext(UserContext);
  const [isHeaderLoaded, setHeaderLoaded] = useState(false);

  useCoreEvents(eventNames.mfer.events, event => {
    if (
      event.eventName === 'react-component' &&
      event.moduleName === 'HeaderModule' &&
      event.data === 'loaded'
    ) {
      setHeaderLoaded(true);
    }
  });

  const shouldShow =
    user.isLoaded &&
    (user.data.isLoggedIn || isHeaderLoaded) &&
    utmCampaign &&
    isSavedSearchesLoaded &&
    Boolean(appliedFilters);

  useEffectOnce(
    () => {
      if (savedSearchIsApplied) return;

      loginAndSaveSearch();
    },
    [loginAndSaveSearch, savedSearchIsApplied],
    shouldShow
  );
}
